import { MenuList } from '@app/domain';
import { CommonEnum, InputTypeMapping } from '@domain/models';
import { FileData } from '@shared/models/global.model';
import {
  CommonEnumDTO,
  FileDataDTO,
  FuncCheckByUserAcctDTO,
  InputTypeMappingDTO,
} from '../dtos';
import { MenuListDTO } from '../dtos/menu-list.dto';

export class CommonMapper {
  enumsToDomain(dto: CommonEnumDTO): CommonEnum {
    return {
      dataSourceType: dto.dataSourceType,
      filterActions: dto.filterActions,
      taskType: dto.taskType,
      chatChannelType: dto.chatChannelType,
      taskShift: dto.taskShift,
      taskConfigTrigger: dto.taskConfigTrigger,
      sectorType: dto.sectorType,
      subTaskFormType: dto.subTaskFormType,
      checklistStatus: dto.checklistStatus,
      taskStatus: dto.taskStatus,
      uploadContextType: dto.uploadContextType,
      userRole: dto.userRole,
      stockConfig: dto.stockConfig,
      inputFiledType: dto.inputFiledType,
      shiftType: dto.shiftType,
      notificationType: dto.notificationType,
      notificationTrigger: dto.notificationTrigger,
      notificationAlertType: dto.notificationAlertType,
      auditLogModule: dto.auditLogModule,
      auditLogType: dto.auditLogType,
      auditLogFilterConfiguration: dto.auditLogFilterConfiguration,
      auditLogConfigEventEnum: dto.auditLogConfigEventEnum,
      auditLogFilterUser: dto.auditLogFilterUser,
      auditLogUserEventEnum: dto.auditLogUserEventEnum,
      systemDataSourceType: dto.systemDataSourceType,
    };
  }

  fileDataToDomain(dto: FileDataDTO[]): FileData[] {
    return dto.map(item => ({
      fileName: item.fileName,
      fileKey: item.fileKey,
      url: item.url,
      header: item.header,
    }));
  }

  inputTypeMappingToDomain(dto: InputTypeMappingDTO[]): InputTypeMapping[] {
    return dto.map(item => ({
      inputType: item.inputType,
      systemDataType: item.systemDataType,
    }));
  }

  menuListToDomain(dtos: MenuListDTO[]): MenuList[] {
    return dtos.map(dto => ({
      id: dto.id,
      disabled: dto.disabled,
      funcCode: dto.funcCode,
      funcName: dto.funcName,
      menu: dto.menu,
      text: dto.text,
    }));
  }

  funcCheckByUserAcctToDomain(
    dto: FuncCheckByUserAcctDTO
  ): Record<string, boolean> {
    return dto.data;
  }
}
